import React, { useState, useEffect } from "react";
import GenericList from "../components/GenericList";
import { Switch } from "@mui/material"; // Usando Material-UI para el switch
import {
  obtenerTiposDeTramite,
  eliminarTipoDeTramite,
} from "../services/tipoTramite.service";
import { ACTION_BUTTONS } from "../config/constants";
import { Modal as ModalAntd } from "antd";
import Modal from "../components/Modal";
import TiposDeTramiteForm from "../components/TiposDeTramiteForm";

const TiposDeTramitesListPage = () => {
  const [tiposDeTramitesList, setTiposDeTramitesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [orderByField, setOrderByField] = useState("id");
  const [orderByDirection, setOrderByDirection] = useState("asc");
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalWidth, setModalWidth] = useState("450px");
  const [reload, setReload] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { confirm } = ModalAntd;

  // Función para obtener los datos
  const fetchTiposDeTramites = async () => {
    const oficinasList = await obtenerTiposDeTramite();
    setTiposDeTramitesList(oficinasList.data);
  };

  useEffect(() => {
    fetchTiposDeTramites();
  }, [currentPage, currentPageSize, orderByField, orderByDirection, reload]);

  const listColumns = [
    { title: "Nombre", field: "descripcion" },
    { title: "Oficina inicial", field: "nombre_oficina" },
    { title: "Cantidad de requisitos", field: "requisitos_cantidad" },
  ];

  const listActionButtons = [ACTION_BUTTONS.EDIT, ACTION_BUTTONS.DELETE];

  const onCreateAction = () => {
    setModalTitle(`ALTA DE TIPO DE TRÁMITE`);
    setModalContent(
      <TiposDeTramiteForm
        setIsVisibleModal={setIsVisibleModal}
        reload={reload}
        setReload={setReload}
        tipoDeTramite={null}
      />
    );
    setIsVisibleModal(true);
  };

  const onEditAction = (row) => {
    setModalTitle(
      <>
        <p>
          EDICIÓN DE TIPO DE TRÁMITE <b>{row.nombre}</b>
        </p>
      </>
    );
    setModalContent(
      <TiposDeTramiteForm
        setIsVisibleModal={setIsVisibleModal}
        reload={reload}
        setReload={setReload}
        tipoDeTramite={row}
      />
    );
    setModalWidth("1050px");
    setIsVisibleModal(true);
  };

  const onDeleteAction = (row) => {
    confirm({
      title: (
        <div style={{ textAlign: "center" }}>
          Eliminación de tipo de trámite
        </div>
      ),
      content: (
        <div style={{ textAlign: "center" }}>
          ¿Estás seguro de eliminar el tipo de trámite?
        </div>
      ),
      okText: "Eliminar",
      cancelText: "Cancelar",
      icon: null, // Puedes agregar un ícono personalizado o dejarlo vacío
      okType: "default", // Cambia el estilo del botón Ok
      okButtonProps: {
        style: { float: "left" }, // Mover el botón Ok a la izquierda
      },
      cancelButtonProps: {
        style: { float: "right" }, // Mover el botón Cancel a la derecha
      },
      onOk() {
        return eliminarTipoDeTramite(row.id).then(() => {
          setReload(!reload);
        });
      },
    });
  };

  return (
    <>
      <GenericList
        columns={listColumns}
        data={tiposDeTramitesList}
        actions={listActionButtons}
        onCreateButtonClick={onCreateAction}
        onEditAction={onEditAction}
        onDeleteAction={onDeleteAction}
        title="Tipos de Trámites"
        onPageChange={(page) => {
          setCurrentPage(page + 1);
        }}
        onPageSizeChange={(pageSize) => {
          setCurrentPageSize(pageSize);
        }}
        onOrderChange={(order) => {
          setOrderByField(order[0]?.orderByField);
          setOrderByDirection(order[0]?.orderDirection);
          setReload(!reload);
        }}
      />
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalWidth}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default TiposDeTramitesListPage;
